import TPhoneBookList from './index.vue';

TPhoneBookList.install = app => {
  app.component(TPhoneBookList.name, TPhoneBookList);
};

export default TPhoneBookList;
